import { css } from 'lit';
export const style = css`
  .one-ux-element--root {
    display: grid;
    overflow-anchor: none; /* Prevents browser from performing unwanted automatic scrolling during drag-n-drop */
  }
`;